import React, { useState, useEffect } from "react";
import { Modal, Calendar, Select, Segmented, Badge, Spin, message, Row, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import AddBarcode2 from "./AddBarcode2"; // *** Import ไฟล์ลูกเข้ามา ***
import ThaiDatePicker from "../../../../hook/ThaiDatePickerNew";
import { baseUrlAREA, HEADERS_BASIC, LOAD_DG } from "../../../API/apiUrlsGarfe";

function PickData({ open, close, date, contractSchema }) {
    const [loading, setLoading] = useState(false);

    // --- States ปฏิทิน ---
    const [calendarMode, setCalendarMode] = useState("month");
    const [calendarValue, setCalendarValue] = useState(dayjs());
    const [calendarPoint, setCalendarPoint] = useState([]);

    // --- States สำหรับสลับหน้า ---
    const [isDetailView, setIsDetailView] = useState(false); // false = Calendar, true = AddBarcode2
    const [selectedDate, setSelectedDate] = useState(null);
    const [dayData, setDayData] = useState([]); // ข้อมูลที่จะส่งให้ AddBarcode2
    // const [dayCloseData, setDayCloseData] = useState(null);

    const [datePicker, setDatePicker] = useState(date ? date : null); // ข้อมูลที่จะส่งให้ AddBarcode2
    const userCompany = localStorage.getItem("COMPANY_ID");
    const [selectedContract, setSelectedContract] = useState(
        contractSchema ? contractSchema : null
    );

    const TESTcontractOptions = [
        // { value: "lsfhp", label: "สัญญา 1" },
        { value: "vsfhp", label: "สัญญา 2" },
        { value: "psfhp", label: "สัญญา 3" },
        { value: "rpsl", label: "สัญญา 3(ใหม่)" },
        { value: "sfhp", label: "สัญญา 8" },
    ];

    const handleLoadData = async () => {
        if (!selectedContract || !datePicker) {
            message.error("กรุณาเลือกประเภทสัญญาและวันที่");
            return;
        }

        setLoading(true);
        // const contractNumbers = arrayTable.map((item) => item.CONTNO);
        const sendData = {
            date: datePicker,
            contractSchema: selectedContract.value,
            // type: selectedContract.value,
            company: userCompany,
            // contractNo: contractNumbers,
        };

        // date: datePicker,
        // check: true

        try {
            const res = await axios.post(baseUrlAREA + LOAD_DG, sendData, {
                headers: HEADERS_BASIC,
            });
            if (res.status === 200) {
                if (
                    Array.isArray(res?.data?.mainData) &&
                    res.data?.mainData?.length > 0
                ) {
                    message.success("พบข้อมูล");
                    setCalendarPoint(res?.data?.mainData);
                } else {
                    message.warning("ไม่พบข้อมูล");
                    setCalendarPoint([]);
                }
            }
        } catch (error) {
            console.error("Error loading calendar:", error);
            message.error("โหลดปฏิทินไม่สำเร็จ");
        } finally {
            setLoading(false);
        }
    };

    // Helper: กรองข้อมูลของวันนั้นๆ
    const getListData = (value) => {
        if (!calendarPoint || calendarPoint?.length === 0) return [];
        return calendarPoint?.filter((item) =>
            dayjs(item.createdAt).isSame(value, "day")
        );
    };

    // เมื่อจิ้มวันที่
    const handleSelectDate = (value) => {
        if (calendarMode === "year") {
            setCalendarValue(value);
            return;
        }
        setCalendarValue(value);

        // 1. ดึง mainData เฉพาะวันที่เลือก (Logic เดิม)
        const mainList = getListData(value);

        // 2. ✅ ดึง closeData (เอาไปทั้งหมด หรือจะกรองก็ได้ แต่นี่คือเอาไปทั้งหมดจาก API)
        // const closeList = calendarPoint?.closeData || [];

        // console.log("Main Data:", mainList);
        // console.log("Close Data:", closeList);

        // เซ็ตข้อมูลและเปลี่ยนหน้า
        setSelectedDate(value);
        setDayData(mainList); // ส่ง MainData
        // setDayCloseData(closeList); // ✅ ส่ง CloseData
        setIsDetailView(true);
    };

    const handleBackToCalendar = () => {
        setIsDetailView(false);
        setDayData([]);
        // setDayCloseData(null); // ✅ เคลียร์ค่า
    };

    const handleClose = () => {
        setIsDetailView(false);
        close(false);
    };

    // --- Render Components ของปฏิทิน ---
    const dateCellRender = (value) => {
        const listData = getListData(value);
        if (listData.length === 0) return null;
        return (
            <div style={{ textAlign: "center" }}>
                {/* <div style={{ marginBottom: 4 }}><Badge count={<FileSearchOutlined style={{ color: "#1890ff" }} />} /></div> */}
                <b>
                    <Badge
                        color="green"
                        text={`รายการ (${listData.length})`}
                        style={{ fontSize: "12px" }}
                    />
                </b>
            </div>
        );
    };

    const monthCellRender = (value) => {
        const count =
            calendarPoint?.filter((item) => {
                const d = dayjs(item.createdAt);
                return d.year() === value.year() && d.month() === value.month();
            }).length || 0;
        return count > 0 ? (
            <div style={{ textAlign: "center", paddingTop: 8 }}>
                <Badge
                    count={count}
                    style={{ backgroundColor: "#52c41a" }}
                    overflowCount={999}
                />
            </div>
        ) : null;
    };

    console.log("selectedContract",selectedContract);
    

    const onChangeContract = (value) => {
        console.log("onChangeContract",value);
        
        setSelectedContract(value)
        setCalendarPoint([]);
    }

    const onChangeDatePicker = (value) => {
        setDatePicker(value)
        setCalendarPoint([]);
    }

    return (
        <Modal
            open={open}
            onCancel={handleClose}
            width={isDetailView ? "90%" : "90%"} // ขยายกว้างขึ้นถ้าเป็นหน้า Table
            centered
            footer={null}
            maskClosable={false}
            title={isDetailView ? "ยิง Barcode" : "ปฏิทินรายการ"}
            styles={{ body: { padding: "20px 0" } }}
        >
            <Spin spinning={loading} tip="กำลังโหลด...">
                {!isDetailView ? (
                    // --- View 1: Calendar ---
                    <>
                        <Row>
                            <Space>
                                <Select
                                    key={userCompany}
                                    size="large"
                                    style={{ minWidth: "auto" }}
                                    placeholder="เลือกสัญญา"
                                    popupMatchSelectWidth={false}
                                    labelInValue // ★ เปิดใช้
                                    value={selectedContract} // ต้องเป็น object { value, label }
                                    // onChange={(obj) => setSelectedContract(obj ?? null)} // obj = { value, label }
                                    onChange={(obj) => onChangeContract(obj ?? null)} // obj = { value, label }
                                    options={TESTcontractOptions}
                                    allowClear
                                    showSearch
                                    optionFilterProp="label"
                                />
                                <ThaiDatePicker
                                    value={datePicker}
                                    onChange={onChangeDatePicker}
                                    // onChange={setDatePicker}
                                    size="large"
                                    disabledDate={(current) => {
                                        // ถ้า current มีค่า และ วันที่ "ไม่ใช่ 12" และ "ไม่ใช่ 26" -> ให้ disable (true)
                                        return (
                                            current && current.date() !== 12 && current.date() !== 26
                                        );
                                    }}
                                />
                                <Button
                                    type="primary"
                                    icon={<SearchOutlined />}
                                    size="large"
                                    style={{
                                        borderRadius: "8px",
                                        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                        fontWeight: "bold",
                                        background: "linear-gradient(135deg, #667eea, blue)",
                                        border: "none",
                                    }}
                                    onClick={handleLoadData}
                                    disabled={loading}
                                >
                                    ค้นหา
                                </Button>
                            </Space>
                        </Row>
                        <Calendar
                            value={calendarValue}
                            mode={calendarMode}
                            onSelect={handleSelectDate}
                            onPanelChange={(v, m) => {
                                setCalendarValue(v);
                                setCalendarMode(m);
                            }}
                            cellRender={(current, info) => {
                                if (info.type === "date") return dateCellRender(current);
                                if (info.type === "month") return monthCellRender(current);
                                return info.originNode;
                            }}
                            headerRender={({ value, type, onChange, onTypeChange }) => {
                                const cur = value.clone();
                                const years = Array.from(
                                    { length: 11 },
                                    (_, i) => dayjs().year() - 5 + i
                                );
                                const months = Array.from({ length: 12 }, (_, i) => ({
                                    value: i,
                                    label: dayjs().month(i).format("MMM"),
                                }));
                                return (
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 8,
                                            justifyContent: "flex-end",
                                            padding: 8,
                                        }}
                                    >
                                        <Select
                                            size="small"
                                            value={cur.year()}
                                            options={years.map((y) => ({ value: y, label: y }))}
                                            onChange={(y) => setCalendarValue(cur.year(y))}
                                        />
                                        <Select
                                            size="small"
                                            value={cur.month()}
                                            options={months}
                                            onChange={(m) => setCalendarValue(cur.month(m))}
                                            disabled={type === "year"}
                                        />
                                        <Segmented
                                            size="small"
                                            value={type === "year" ? "Year" : "Month"}
                                            options={["Month", "Year"]}
                                            onChange={(v) =>
                                                onTypeChange(v === "Year" ? "year" : "month")
                                            }
                                        />
                                    </div>
                                );
                            }}
                        />
                    </>
                ) : (
                    // --- View 2: AddBarcode2 (Detail) ---
                    <AddBarcode2
                        data={dayData} // mainData (ที่กรองวันที่แล้ว)
                        date={selectedDate}
                        onBack={handleBackToCalendar}
                        refreshCalendar={handleLoadData}
                        selectedContract={selectedContract}
                    />
                )}
            </Spin>
        </Modal>
    );
}

export default PickData;
